var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSendAndPaySolid = function SvgSendAndPaySolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.53 19.53a.747.747 0 0 0 .22-.53A2.25 2.25 0 0 1 14 16.75h1.878a2.25 2.25 0 0 1 2.122-3 .75.75 0 0 0 .75-.75V5A2.75 2.75 0 0 0 16 2.25H6A2.75 2.75 0 0 0 3.25 5v16a.75.75 0 0 0 1.166.624l2.488-1.659L8.47 21.53a.75.75 0 0 0 1.06 0l2-2ZM11.25 7a.75.75 0 0 0-1.5 0v.586a2.083 2.083 0 0 0 .083 4.165h1.334a.583.583 0 1 1 0 1.166h-.633a.768.768 0 0 0-.068 0h-.658a.584.584 0 0 1-.525-.29.75.75 0 1 0-1.3.748 2.083 2.083 0 0 0 1.767 1.043V15a.75.75 0 0 0 1.5 0v-.584a2.084 2.084 0 0 0-.083-4.165H9.833a.583.583 0 0 1 0-1.167h1.334a.583.583 0 0 1 .55.291.75.75 0 1 0 1.3-.749 2.083 2.083 0 0 0-1.767-1.042V7Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.47 16.53a.75.75 0 1 1 1.06-1.06l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l1.72-1.72H14a.75.75 0 0 1 0-1.5h5.19l-1.72-1.72Z",
    fill: "currentColor"
  })));
};
export default SvgSendAndPaySolid;